import { VerificationStatus } from '../modules/provider/PaymentSettings.types';
import type { RootState } from './models';

const dismissed = (
  state: RootState,
) => state.stripeIdentityVerification.dismissed;

const isOnboarded = (
  state: RootState,
) => state.stripeIdentityVerification.isOnboarded;

const needsFullSsn = (
  state: RootState,
) => state.stripeIdentityVerification.needs_full_ssn;

const needsCompanyEin = (
  state: RootState,
) => state.stripeIdentityVerification.needs_company_ein;

const needsLegalDocument = (
  state: RootState,
) => state.stripeIdentityVerification.needs_legal_document;

const needsValidAddress = (
  state: RootState,
) => state.stripeIdentityVerification.needs_valid_address;

const onCommissionPlan = (
  state: RootState,
) => state.stripeIdentityVerification.onCommissionPlan;

const isOnboardedMarketingPro = (
  state: RootState,
) => isOnboarded(state) && onCommissionPlan(state);

const isPending = (
  { stripeIdentityVerification }: RootState,
): boolean => stripeIdentityVerification.status === VerificationStatus.PENDING;

const isUnverified = (
  { stripeIdentityVerification }: RootState,
): boolean => stripeIdentityVerification.status === VerificationStatus.UNVERIFIED;

const isPaymentsSetupMandatory = (
  { stripeIdentityVerification }: RootState,
): boolean => stripeIdentityVerification.isPaymentsSetupMandatory;

const modalVisible = (state: RootState) => isOnboardedMarketingPro(state)
  && !dismissed(state)
  && isUnverified(state);

export default {
  dismissed,
  isOnboarded,
  isOnboardedMarketingPro,
  isPaymentsSetupMandatory,
  isPending,
  isUnverified,
  modalVisible,
  needsCompanyEin,
  needsFullSsn,
  needsLegalDocument,
  needsValidAddress,
  onCommissionPlan,
};
